import { render, staticRenderFns } from "./signature-submission.component.vue?vue&type=template&id=4c5b939b"
import script from "./signature-submission.component.ts?vue&type=script&lang=ts&external"
export * from "./signature-submission.component.ts?vue&type=script&lang=ts&external"
import style0 from "./signature-submission.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports